<template>
  <NewCheckout :isQuote="true" />
</template>

<script setup lang="ts">
import NewCheckout from './NewCheckout.vue'
</script>
